import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiia = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 99 99",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5941_1744)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M49.5 99C21.78 99 14.32 97.6 7.86 91.14C1.4 84.68 0 77.22 0 49.5C0 21.78 1.4 14.36 7.86 7.86C14.32 1.36 21.78 0 49.5 0C77.22 0 84.68 1.4 91.14 7.86C97.6 14.32 99 21.78 99 49.5C99 77.22 97.64 84.64 91.14 91.14C84.64 97.64 77.22 99 49.5 99Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M68.9101 49.46C68.0959 49.46 67.315 49.1366 66.7392 48.5608C66.1635 47.9851 65.8401 47.2042 65.8401 46.39C65.8401 45.5758 66.1635 44.7949 66.7392 44.2192C67.315 43.6434 68.0959 43.32 68.9101 43.32H73.8501V49.46H68.9101ZM78.0001 39.75H68.4301C64.3801 39.75 61.6101 42.4 61.6101 46.21C61.5562 47.5808 61.9676 48.9296 62.7773 50.037C63.587 51.1445 64.7475 51.9455 66.0701 52.31L60.8501 60.25H65.4701L70.1601 53H73.8501V60.22H78.0001V39.75ZM26.3101 45.13V39H34.3101V56.48H24.2701C25.3501 54.59 26.3101 50.22 26.3101 45.13ZM38.5901 35H22.2201V45.29C22.2201 50.54 21.3001 54.63 20.0601 56.48H18.0601V65.83H22.1101V60.29H37.4701V65.83H41.5201V56.48H38.5901V35ZM50.9401 56.76L50.5801 56.52L55.3601 39.75H45.6901L44.6901 43.48H50.3001L46.6501 56.28C46.4828 56.8133 46.4473 57.3793 46.5465 57.9293C46.6458 58.4794 46.8768 58.9972 47.2198 59.4385C47.5628 59.8798 48.0076 60.2315 48.5162 60.4634C49.0248 60.6952 49.5819 60.8004 50.1401 60.77C51.0143 60.7573 51.8658 60.4897 52.5901 60L59.1701 55.55L57.1701 52.55L50.9401 56.76ZM53.7501 35.9C55.7501 35.9 56.6401 35.14 56.6401 33.33C56.6401 31.52 55.7601 30.69 53.7501 30.69C51.7401 30.69 50.8601 31.45 50.8601 33.33C50.8601 35.21 51.7101 35.9 53.7501 35.9Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5941_1744",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 99,
			height: 99,
			fill: "white"
		})
	}) })]
});
export default SvgDiia;
